import { transform, isEqual, isObject, debounce } from 'lodash-es';

export function difficultyToStr (difficulty) {
  if (difficulty === 1) return 'easy';
  else if (difficulty === 2) return 'medium';
  else if (difficulty === 3) return 'hard';
}

export function difficultyToInt (difficulty) {
  if (difficulty === 'easy') return 1;
  else if (difficulty === 'medium') return 2;
  else if (difficulty === 'hard') return 3;
}

export function objListToArr (obj, transformer = v => v) {
  return Object.keys(obj)
    .filter(k => obj[k])
    .map(transformer);
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export function diffObjects (object, base) {
  function changes (object, base) {
    return transform(object, function (result, value, key) {
      if (!isEqual(value, base[key])) {
        result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
}

/**
 * Debounce with a reduce args accumulator
 */
export function debounceReduce (func, wait, combine) {
  let allargs;
  const wrapper = debounce(() => {
    const args = allargs;
    allargs = undefined;
    func.apply(this, args);
  }, wait, { leading: true, trailing: true });
  return (...args) => {
    allargs = combine.apply(this, [allargs, args]);
    wrapper();
  };
}
